var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { computedAsync } from "@vueuse/core";
import { computed } from "vue";
import { useDatasetPathDestination } from "@/composables/datasetPathDestination";
import { getAppRoot } from "@/onload/loadConfig";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatasetAsImage',
    props: {
        historyDatasetId: null,
        path: null
    },
    setup(__props) {
        const props = __props;
        const { datasetPathDestination } = useDatasetPathDestination();
        const pathDestination = computed(() => datasetPathDestination.value(props.historyDatasetId, props.path));
        const imageUrl = computed(() => {
            var _a;
            if (props.path === undefined || props.path === "undefined") {
                return `${getAppRoot()}dataset/display?dataset_id=${props.historyDatasetId}`;
            }
            return (_a = pathDestination.value) === null || _a === void 0 ? void 0 : _a.fileLink;
        });
        const isImage = computedAsync(() => __awaiter(this, void 0, void 0, function* () {
            if (!imageUrl.value) {
                return null;
            }
            const res = yield fetch(imageUrl.value);
            const buff = yield res.blob();
            return buff.type.startsWith("image/");
        }), null);
        return { __sfc: true, datasetPathDestination, props, pathDestination, imageUrl, isImage };
    }
});
